import type { SYSTableDefIds } from "../../../../../../src"
import { html, SYSBaseElement } from "../../../../../../src"
import type { DialogHolderParams } from "../../../../../../src/library/dialog/dialogapi"
import { DialogClose } from "../../../../../../src/library/dialog/dialogapi"
import { FormGet } from "../../../../../../src/library/forms/formapi"
import { NavDef } from "../../../../../../src/library/table/navcontrol"
import { _ColumnColumnFilter } from "../../../../../../src/library/table/table"
import {
  SYSColumnDef,
  TableColumnFilter,
  TableGet,
  _TableGetReturnType,
  TableRebuild,
} from "../../../../../../src/library/table/tableapi"
import { HeaderMenuFilterFieldsSetState } from "../../../../../../src/library/table/tablerowheadermenu/tablesettings/hookactions"
import { T } from "../../../../../../src/textapi"
import { _SetFilter } from "./helpers"
import { SYSTableSettings_ColumnFilter } from "./tabledef"

export class SYSTableSettingsColumnFilterDialog extends SYSBaseElement {
  defId: SYSTableDefIds
  columnKey: string
  columnDef: SYSColumnDef
  tableDef: _TableGetReturnType<SYSTableSettings_ColumnFilter>
  filter: _ColumnColumnFilter
  async resetFilter() {
    if (
      await TableColumnFilter(
        this.state.ovl.libState.tableSettings.columnFilter.defId,
        this.columnKey,
        [],
        {
          exclusive: false,
          _innerEvent: true,
        }
      )
    ) {
      await TableRebuild(
        this.state.ovl.libState.tableSettings.columnFilter.defId,
        { showProcess: true }
      )
      HeaderMenuFilterFieldsSetState(
        FormGet("SYSHeaderMenuFilter", { instance: "1" }).formState
      )
    }
    DialogClose("SYSTableSettings_ColumnFilter")
  }
  async init() {
    this.dialog = "SYSTableSettings_ColumnFilter"
    this.defId = "SYSTableSettings_ColumnFilter"
    this.tableDef = TableGet<SYSTableSettings_ColumnFilter>(this.defId)
    let filterTableDef = TableGet(
      this.state.ovl.libState.tableSettings.columnFilter.defId
    )
    this.columnKey =
      this.state.ovl.libState.tableSettings.columnFilter.columnKey
    this.columnDef = filterTableDef.def.columns[this.columnKey]
    this.filter = JSON.parse(
      JSON.stringify(
        filterTableDef.def.uiState.filter.columns[this.columnKey].columnFilter
      )
    )
    await super.init()
  }
  async getUI() {
    let dialogHolderParams: DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        tableDefButtonsInFooter: "SYSTableSettings_ColumnFilter",
        dismissedCallbackFn: () => {
          DialogClose(this.dialog)
        },

        body: () =>
          html`<ovl-table
            class="fd-table fd-table--no-horizontal-borders"
            .props=${() => <SYSTableDefIds>"SYSTableSettings_ColumnFilter"}
          >
          </ovl-table>`,
        footer: async () => {
          let filter = this.filter
          let hasSelected =
            this.tableDef.getKeys({ byKeys: "Selected" }).length > 0

          let setFilterButton = html`<button
            @click=${async (e) => await _SetFilter(this.filter.exclusive)}
            class="fd-button"
            ?disabled=${!hasSelected}
          >
            <i class="sap-icon--filter"></i>
          </button>`

          let clearFilterButton = html`<button
            @click=${async (e) => await this.resetFilter()}
            class="fd-button"
            ?disabled=${filter.type === "none"}
          >
            <i class="sap-icon--clear-filter"></i>
          </button>`

          let exklCheck
          if (
            this.state.ovl.libState.tableSettings.columnFilter.allowExclusive
          ) {
            exklCheck = html`
              <span>
                <input
                  type="checkbox"
                  class="fd-checkbox"
                  id="Ai4ez612c"
                  ?disabled=${!hasSelected}
                  ?checked=${filter.exclusive}
                  .checked=${filter.exclusive}
                  @input=${(e) => {
                    filter.exclusive = !filter.exclusive
                  }}
                />
                <label class="fd-checkbox__label" for="Ai4ez612c">
                  <div class="fd-checkbox__label-container">
                    <span class="fd-checkbox__text"
                      >${T("SYSFilterExclusive")}</span
                    >
                  </div>
                </label>
              </span>
            `
          }

          return html`${exklCheck}
            <span class="ovl-adjust"></span>
            ${setFilterButton}
            <span class="ovl-adjust"></span>
            ${clearFilterButton}`
        },
      },
      dialogType: this.dialog,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
